import { render } from "./OfficeCard.vue?vue&type=template&id=10d9c8f3&scoped=true"
import script from "./OfficeCard.vue?vue&type=script&lang=js"
export * from "./OfficeCard.vue?vue&type=script&lang=js"

import "./OfficeCard.vue?vue&type=style&index=0&id=10d9c8f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d9c8f3"]])

export default __exports__